import { FC, memo } from 'react';
import { useParams } from 'react-router';

import { AppAutocomplete, DomainPunycode } from '@/common/components';
import { AppAutocompleteComponentProps } from '@/common/interfaces';
import { parseSelectData } from '@/common/utils';

import { useAutocompleteAllDomainsQuery } from '@/modules/Domains';

interface Props extends AppAutocompleteComponentProps {
  excludeId?: string;
}

export const DomainsAllAutocomplete: FC<Props> = memo(({ excludeId, ...props }) => {
  const { domainId } = useParams();

  return (
    <AppAutocomplete<typeof useAutocompleteAllDomainsQuery>
      { ...props }
      notFoundDescription="Немає доменів"
      placeholder="Знайдіть домен"
      excludedIds={ [domainId, excludeId].filter((id): id is string => Boolean(id)) }
      options={ (data) =>
        parseSelectData(
          data?.map((el) => ({ ...el, name: DomainPunycode.stringFormat(el.name) })),
          {
            value: 'id',
            label: 'name'
          }
        )
      }
      query={ useAutocompleteAllDomainsQuery }
    />
  );
});
